var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{attrs:{"type":"hidden","name":_vm.csrfToken.name},domProps:{"value":_vm.csrfToken.value}})
}
var staticRenderFns = []

export { render, staticRenderFns }